import lf from 'lovefield'

export function const_coherenceengins (schemaBuilder) {
  schemaBuilder.createTable('const_coherenceengins')
  		.addColumn('id', lf.Type.INTEGER)
      .addColumn('const_famillesengins_const_options_const_phases_id', lf.Type.INTEGER)
      .addColumn('const_famillesengins_const_options_const_phases_lie_id', lf.Type.INTEGER)
      .addColumn('utilisation', lf.Type.STRING)
      .addColumn('commentaire', lf.Type.STRING)
      .addPrimaryKey(['id']);
}

/*
CREATE TABLE IF NOT EXISTS `const-cubaturestypes` (
  `code` varchar(3) NOT NULL,
  `nom` varchar(20) NOT NULL,
  PRIMARY KEY (`code`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constCoherenceEngins.schema.js